export default "__VITE_ASSET__Dlcpqd$8__"